module.exports = __webpack_public_path__ + "img/53.8ba09398.jpg";